import { Link, NavLink, useLocation } from 'react-router-dom';
import { ShoppingBag, Menu, X, Phone } from 'lucide-react';
import { useState } from 'react';
import { useCart } from '@/context/CartContext';

const NAV_LINKS = [
    { to: '/', label: 'Home' },
    { to: '/job-work', label: 'Job Work' },
    { to: '/standard-package', label: 'Standard Package' },
    { to: '/pre-crafted-modules', label: 'Pre-Crafted Modules' },
    { to: '/about', label: 'About' },
];

export default function Nav() {
    const [open, setOpen] = useState(false);
    const { totalCount } = useCart();
    const loc = useLocation();
    if (loc.pathname.startsWith('/admin')) return null;

    return (
        <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-slate-200" data-testid="site-nav">
            <div className="kanbr-container flex items-center justify-between py-3">
                <Link to="/" className="flex items-center gap-2.5" data-testid="brand-link">
                    <div className="w-9 h-9 bg-blue-900 text-white flex items-center justify-center font-display font-bold text-lg">K</div>
                    <div className="leading-tight">
                        <div className="font-display font-bold text-base text-slate-900">Kanbr</div>
                        <div className="text-[9px] uppercase tracking-[0.28em] text-slate-500">Concepts</div>
                    </div>
                </Link>

                <nav className="hidden lg:flex items-center gap-7">
                    {NAV_LINKS.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                            className={({ isActive }) => `text-sm font-medium transition-colors ${isActive ? 'text-blue-900' : 'text-slate-600 hover:text-blue-900'}`}
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <a href="tel:+919773704406" className="hidden md:flex items-center gap-2 text-sm text-slate-700 hover:text-blue-900" data-testid="nav-call">
                        <Phone className="w-4 h-4" /> 9773704406
                    </a>
                    <Link to="/cart" className="relative p-2 hover:bg-slate-100 transition-colors" data-testid="nav-cart">
                        <ShoppingBag className="w-5 h-5 text-slate-800" />
                        {totalCount > 0 && (
                            <span className="absolute -top-1 -right-1 bg-amber-600 text-white text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full">{totalCount}</span>
                        )}
                    </Link>
                    <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
                        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden border-t border-slate-200 bg-white">
                    <nav className="kanbr-container flex flex-col py-4 gap-3">
                        {NAV_LINKS.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                onClick={() => setOpen(false)}
                                className="text-sm font-medium text-slate-700"
                                data-testid={`mnav-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                            >
                                {l.label}
                            </NavLink>
                        ))}
                    </nav>
                </div>
            )}
        </header>
    );
}
